import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TopTitleBar = ({ enterpriseData, user_name }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem("darkMode", newMode);
      return newMode;
    });
  };

  const finalEnterpriseData = enterpriseData || {
    enterprise_id: sessionStorage.getItem("enterprise_id"),
    enterprise_name: sessionStorage.getItem("enterprise_name"),
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between mb-2 mt-1"
      style={{ gap: "8px", fontSize: "20px" }}
    >
      {/* Left Title Section */}
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        <span
          className="fw-bold"
          style={{
            cursor: "pointer",
            fontSize: '20px',
            color: currentPath === "/conversation-management" ? "#909090" : "var(--dark-color)",
             fontSize:"20px"
          }}
          onClick={() => {
            sessionStorage.removeItem("enterprise_id");
            sessionStorage.removeItem("enterprise_name");
            navigate("/superadmin/conversation-management");
          }}
        >
          Conversation Management Details
        </span>

        {finalEnterpriseData?.enterprise_name && (
          <>
            <span className="fw-bold refresh-prompts">/</span>
            <span
              className="fw-bold"
              style={{
                cursor: "pointer",
                color:
                  currentPath === "/superadmin/chat-usage-management"
                    ? "#909090"
                    : "var(--dark-color)",
                     fontSize:"20px"
              }}
              onClick={() =>
                navigate("/superadmin/chat-usage-management", {
                  state: { enterprise: finalEnterpriseData },
                })
              }
            >
              {finalEnterpriseData.enterprise_name}
            </span>
          </>
        )}

        {user_name && (
          <>
            <span className="fw-bold refresh-prompts">/</span>
            <span
              className="fw-bold"
              style={{
                color:
                  currentPath === "/superadmin/user-session-management"
                    ? "#909090"
                    : "var(--dark-color)",
                     fontSize:"20px"
              }}
            >
              {user_name}
            </span>
          </>
        )}
      </div>

      {/* Dark Mode Toggle Button */}
      {/* <button
        onClick={toggleDarkMode}
        className="btn btn-sm bgcolor textwhite fw-semibold px-3"
      >
        {darkMode ? "🌙 Dark" : "☀️ Light"}
      </button> */}
    </div>
  );
};

export default TopTitleBar;
